import { getRemoteConfig } from '@/api/remote-config';
import { MealParser } from './parse';

function checkBundleSelectedForLeg(
  bundleMealsDataForAllLegs,
  departureStation,
  arrivalStation,
) {
  const bundleMealsForLeg = bundleMealsDataForAllLegs.filter(
    (bundleMealData) => {
      return (
        bundleMealData.departureStation === departureStation &&
        bundleMealData.arrivalStation === arrivalStation
      );
    },
  );
  return bundleMealsForLeg.length > 0;
}

function filterMealDataForLeg(meals, excludeMealsIds) {
  const excludeMealsData = [];
  const filteredMealData = [];

  meals.forEach((meal) => {
    // if (Number(meal.price) === 0 && excludeMealsIds.includes(meal.id)) {
    if (excludeMealsIds.includes(meal.id)) {
      excludeMealsData.push(meal);
    } else {
      filteredMealData.push(meal);
    }
  });

  return {
    filteredMealData,
    excludeMealsData,
  };
}

function resetAlaCarteMealsForLeg(leg) {
  const { meals, excludedMeals } = leg;
  if (excludedMeals && excludedMeals.length > 0) {
    leg.meals = [...meals, ...excludedMeals];
    leg.meals = leg.meals.sort((a, b) => a.price - b.price);
    leg.excludedMeals = [];
  }
}

export async function excludeAlaCarteMealsForSelectedBundle(
  allAlaCarteMealsForAllLegs,
  allBundleMealsDataForAllLegs,
) {
  if (allAlaCarteMealsForAllLegs.length === 0) {
    return allAlaCarteMealsForAllLegs;
  }

  const excludeMealsIds: string[] = await getRemoteConfig('excludeMeals');
  if (!excludeMealsIds || excludeMealsIds.length === 0) {
    return allAlaCarteMealsForAllLegs;
  }

  allAlaCarteMealsForAllLegs.forEach((leg) => {
    const { arrivalStation, departureStation, meals } = leg;
    const isBundleSelectedForLeg = checkBundleSelectedForLeg(
      allBundleMealsDataForAllLegs,
      departureStation,
      arrivalStation,
    );

    if (isBundleSelectedForLeg === true) {
      if (!leg.excludedMeals || leg.excludedMeals.length === 0) {
        const { filteredMealData, excludeMealsData } = filterMealDataForLeg(
          meals,
          excludeMealsIds,
        );
        leg.meals = filteredMealData;
        leg.excludedMeals = excludeMealsData;
      }
    } else {
      resetAlaCarteMealsForLeg(leg);
    }
  });

  allAlaCarteMealsForAllLegs = MealParser.sortMealsByPrice(
    allAlaCarteMealsForAllLegs,
  );

  return allAlaCarteMealsForAllLegs;
}

export function resetFullAlaCarteMeals(allAlaCarteMealsForAllLegs) {
  if (allAlaCarteMealsForAllLegs.length === 0) {
    return allAlaCarteMealsForAllLegs;
  }

  allAlaCarteMealsForAllLegs.forEach((leg) => {
    resetAlaCarteMealsForLeg(leg);
  });

  allAlaCarteMealsForAllLegs = MealParser.sortMealsByPrice(
    allAlaCarteMealsForAllLegs,
  );

  return allAlaCarteMealsForAllLegs;
}
